<div class="status-wrapper video-progress">
    <div class="progress progress-{{ paused ? 'paused' : 'play' }}">
        <div class="video-progress__container" ref:container on:click="fire('toggle')">
            <svg ref:svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                <circle class="st0" r="25" cx="27" cy="27" stroke-dasharray="{{ circumference(25) }}" stroke-dashoffset="0"></circle>
                <circle ref:progress class="bar" r="25" cx="27" cy="27" stroke-dasharray="{{ circumference(25) }}" stroke-dashoffset="0" transform="rotate(-90 27 27)" style="stroke-dashoffset: -{{ (t/d) * circumference(25) }}px;"></circle>

                <g class="pause-button" style="display:{{ paused ? 'none' : 'inherit' }}">
                    <rect x="22" y="18" width="4" height="18"/>
                    <rect x="30" y="18" width="4" height="18"/>
                </g>
                <polygon class="play-button" points="22.5,36 22.5,17 38,27" 
                    style="display:{{ paused ? 'inherit' : 'none' }}"/>
            </svg>
        </div>
    </div>
</div>


<script>
function pad ( num ) {
    return num < 10 ? '0' + num : num;
}

export default {
    data() {
        return {
            t: 0,
            d: 0,
            paused: true
        }
    },

    helpers: {
        format: function ( time ) {
            if ( isNaN( time ) ) return '--:--.-';
            var minutes = Math.floor( time / 60 );
            var seconds = ( time % 60 ).toFixed( 1 );
            return minutes + ':' + pad( seconds )
        },
        circumference: function (r) {
            return Math.PI * (r*2);
        }
    },
}
</script>